module.exports = __webpack_public_path__ + "img/404.610cfa85.png";